import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OnboardingMenu } from 'src/app/enums/enums';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { ThresholdService } from 'src/app/services/core/threshold/threshold.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-threshold',
  templateUrl: './threshold.component.html',
  styleUrls: ['./threshold.component.css']
})
export class ThresholdComponent implements OnInit {
  thresholdForm!: FormGroup;
  search: any;
  thrsholdId: any;
  submitted = false;
  companyId: any;
  spaceTypes:any;


  // Edit Modal Inputs and Outputs
  @Input() threshold: any;
  @Input() source: any;
  @Output() onSaveThreshold = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  // Edit Modal Inputs and Outputs End

  constructor(
    private thresholdService: ThresholdService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private spaceTypeService: SpaceTypeService
  ) {}

  ngOnInit(): void {
    this.getSpaceType();
    if (this.source === 'modal' && this.threshold) {
      this.thrsholdId = this.threshold.id;
      this.companyId = this.threshold.company;
      this.getThresHoldById();
    } else {
      this.thrsholdId = this.route.snapshot.params['thrsholdId'];
      this.companyId = this.route.snapshot.params['companyId'];
      if (this.threshold) {
            this.getThresHoldById();
      }
    }

    this.thresholdForm = this.fb.group({
      miles: ["", Validators.required],
      trips: ["", Validators.required],
      spaceType: ["", Validators.required],
      isActive:[true],
      amount: ["", Validators.required],
      company: [""]
    });
  }

  onSubmit(){
    this.submitted = true;
    this.thresholdForm.patchValue({
      company: this.companyId,
    });
    if (this.thresholdForm.invalid) {
      return;
    }
    const payload = this.thresholdForm.value
    this.thresholdService.saveThreshold(this.thrsholdId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data){
        // this.router.navigateByUrl(`/credentials/${this.companyId}`);
        if (this.source === 'modal') {
          this.onSaveThreshold.emit(data);
        } else {
          this.router.navigate(['/credentials', this.companyId], { fragment: OnboardingMenu.THRESHOLD });

        }
      }
    },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
  )
  }

  getThresHoldById(){
    this.thresholdService.getThresholdById(this.thrsholdId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.thresholdForm.patchValue({
          ...data
        });
      }
    })
  }

  getSpaceType(){
    const queryparams = {
      isActive: true,
      limit:9999
    }
    this.spaceTypeService.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spaceTypes = data.results;
      }
    })
  }

  get form() {
    return this.thresholdForm.controls;
  }
}
